export interface TooltipItem {
  datasetLabel: string
  value: number | null
  color: string
  format?: 'money' | 'percent'
  dashed?: boolean
  isBand?: boolean
  isForecastBand?: boolean
}

export interface TooltipData {
  title: string
  items: TooltipItem[]
  forecastRange?: { low: number; high: number } | null
}

export interface Position {
  left: number
  top: number
}

export const HIDDEN: Position = { left: -9999, top: -9999 }
